import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { RoomType } from './room-type.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
}

@Injectable({
  providedIn: 'root',
})
export class RoomTypeService {
  constructor(private http: HttpClient, private utilService: UtilService) {}

  private apiUrl = environment.apiEndpoint + 'room_types';

  getFilterCriteria() {
    let defaultParams: ExtendedDefaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getRoomTypes(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getRoomType(id: string, params = null): Observable<RoomType> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<RoomType>(`${this.apiUrl}/${id}`, {
      params: queryParams,
    });
  }

  // Save / Update
  saveRoomType(roomTypeId: string, roomType: RoomType, lang = ''): Observable<RoomType> {
    const body = {
      room_type: roomType,
      lang: lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
    };

    if (!roomTypeId) {
      return this.http.post<RoomType>(`${this.apiUrl}`, body);
    } else {
      return this.http.put<RoomType>(`${this.apiUrl}/${roomTypeId}`, body);
    }
  }
}
